<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="scss">
#app {
  font-family: "Poppins", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.toasted-container {
  font-family: "Poppins", sans-serif !important;
}

* {
  box-sizing: border-box;
}

html,
body {
  padding: 0;
  margin: 0;
  width: 100%;
  min-height: 75vh;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: lightpink;
}

::-webkit-scrollbar-thumb {
  background: darkred;

  border-radius: 1rem;
}

::-webkit-scrollbar-thumb:hover {
  background: lighten($color: darkred, $amount: 10);
}
</style>